import React, { useEffect, useState } from 'react'
import * as Yup from "yup";
import { Button, TextField } from '@mui/material';
import { Form, FormikProvider, useFormik } from "formik";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import { AUTH_API_URL } from "src/api/axios";
import { useMutation, useQuery } from 'react-query';
import { useSnackbar } from "notistack";

const BankDetail = () => {
   const axiosPrivate = useAxiosPrivate();
   const { enqueueSnackbar } = useSnackbar();
   const [page, setPage] = useState(0);
   const [filterName, setFilterName] = useState('');
   const [storeBankDetail, setStoreBankDetail] = useState();
   const [bankDetailStatus, setBankDetailStatus] = useState();

   async function getProfile() {
      const response = await axiosPrivate.get(AUTH_API_URL.getProfile, { params: { params: { search: filterName } } });
      setStoreBankDetail(response?.data?.vendor?.bank_details)
      setBankDetailStatus(response?.data?.vendor)
      return response.data;
   }

   const { isLoading, data: appVersion, refetch } = useQuery(['appVersion', page, filterName], () => getProfile(), { keepPreviousData: true, })

   const completedSchema = Yup.object().shape({
      account_name: Yup.string()
         .min(1, "Account Name can set of between 2 and 50 characters!")
         .max(50, "Account Name can set of between 2 and 50 characters!")
         .required("Account Name is required"),
      account_number: Yup.number()
         .required('Account number is required')
         .min(1, "you can't enter less than 0 digits in account number"),
         // .max(99999999999999999, "you can't enter more than 17 digits in account number"),
      bank_name: Yup.string()
         .min(1, "Bank Name can set of between 2 and 50 characters!")
         .max(50, "Bank Name can set of between 2 and 50 characters!")
         .required("Bank Name is required"),
      sort_code: Yup.string()
         .min(1, "Sort Code can set of between 2 and 50 characters!")
         .max(50, "Sort Code set of between 2 and 50 characters!")
         .required("Sort Code is required"),
   });

   const formik = useFormik({
      initialValues: {
         bank_name: "",
         sort_code: "",
         account_name: "",
         account_number: "",
      },
      validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {
         const informationObj = {
            bank_name: values.bank_name,
            sort_code: values.sort_code,
            account_name: values.account_name,
            account_number: values.account_number,
         };
         await addUpdateBankDetails(informationObj);
         setSubmitting(false);
      },
   });

   const { mutateAsync: addUpdateBankDetails } = useMutation(
      async (data) => {
         return await axiosPrivate.put(AUTH_API_URL.addBank, data)
      },
      {
         onSuccess: ({ data }) => {
            refetch();
            enqueueSnackbar(data?.message, {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
         },
         onError: (error) => {
            const errorData = error.response.data.errors;
            Object.keys(errorData).forEach((key) => {
               if (key === "account_name") {
                  setFieldError("account_name", errorData[key]);
               } else if (key === "account_number") {
                  setFieldError(key, errorData[key]);
               }
               else if (key === "bank_name") {
                  setFieldError(key, errorData[key]);
               }
               else {
                  setFieldError(key, errorData[key]);
               }
            });
         },
      }
   );
   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps } = formik;

   useEffect(() => {
      setFieldValue("account_name", storeBankDetail?.account_name !== null ? storeBankDetail?.account_name : "")
      setFieldValue("account_number", storeBankDetail?.account_number !== null ? storeBankDetail?.account_number : "")
      setFieldValue("bank_name", storeBankDetail?.bank_name !== null ? storeBankDetail?.bank_name : "")
      setFieldValue("sort_code", storeBankDetail?.sort_code !== null ? storeBankDetail?.sort_code : "")
   }, [storeBankDetail])

   return (
      <>
         <div className="card" style={{ "width": "100%" }}>
            <h5 className="card-header">Bank Details</h5>
            <div className="card-body">
               <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                     <div className="row">
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField label='Account Name' name='account_name' autoComplete='off' fullWidth variant='outlined'
                                 {...getFieldProps("account_name")}
                                 error={Boolean(touched.account_name && errors.account_name)}
                                 helperText={touched.account_name && errors.account_name}
                              />
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="form-group mb-4">
                              <TextField
                                 label='Account Number'
                                 autoComplete='off'
                                 fullWidth
                                 variant='outlined'
                                 {...getFieldProps("account_number")}
                                 error={Boolean(touched.account_number && errors.account_number)}
                                 helperText={touched.account_number && errors.account_number}
                              />
                           </div>
                        </div>
                     </div>
                     <div className="row">
                        <div className='col lg-6'>
                           <div className="form-group mb-4">
                              <TextField
                                 label='Bank Name '
                                 autoComplete='off'
                                 fullWidth
                                 variant='outlined'
                                 {...getFieldProps("bank_name")}
                                 error={Boolean(touched.bank_name && errors.bank_name)}
                                 helperText={touched.bank_name && errors.bank_name}
                              />
                           </div>
                        </div>
                        <div className='col lg-6'>
                           <div className="form-group mb-4">
                              <TextField
                                 label='Sort Code'
                                 autoComplete='off'
                                 fullWidth
                                 variant='outlined'
                                 {...getFieldProps("sort_code")}
                                 error={Boolean(touched.sort_code && errors.sort_code)}
                                 helperText={touched.sort_code && errors.sort_code}
                              />
                           </div>
                        </div>
                     </div>

                     <div className="row">
                        <div className="col-md-3 m-auto">
                           {
                              bankDetailStatus?.bank_request_status !== 2 ?
                                 <div>
                                    <Button
                                       type="submit"
                                       fullWidth
                                       variant="contained"
                                       className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                                    >
                                       submit
                                    </Button>
                                 </div>
                                 :
                                 <></>
                           }
                        </div>
                        {bankDetailStatus?.bank_request_status === 0 ? <h6 style={{ 'color': 'red', margin: '1rem 0', textAlign: 'center' }}>Your Bank Details Is Not Valid. Please Submit Again!!</h6> : ''}
                     </div>
                  </Form>
               </FormikProvider>
            </div>
         </div>
         <div className="modal_card_body custom_scrollbar max_hight500">

         </div>
      </>
   )
}

export default BankDetail